import { apiEnums } from '@nodal/api';
import { useScreening } from '@nodal/core/flows/Screening';
import {
  HipaaConsentForms,
  useHipaaConsentForms,
} from '@nodal/core/flows/Screening/HipaaConsentForms';

import { settings } from 'settings';

const clientId = settings.getHelloSignAppId();

export const HipaaConsentFormsConnected = () => {
  const { currentStep, submit } = useScreening();

  const forms = useHipaaConsentForms({
    currentStep,
    submit,
    clientId,
    skipDomainVerification: !!import.meta.env.DEV,
    consentFormType: apiEnums.DropboxDocumentTypeEnum.ConsentForm,
  });

  if (!forms) {
    return null;
  }

  return <HipaaConsentForms forms={forms} />;
};
